<!-- 计重策略 -->
<template>
  <el-form ref="form" :model="form" label-width="80px" size="mini">
    <div class="row-wrap">
      <el-row v-for="(attach, idx) in form.attachWeights" :key="idx">
        <el-col :xs="24" style="padding: 5px 0px;">
          <el-input v-model="attach.xlabel" style="width:300px;" size="mini">
            <template slot="prepend">{{ "设置名" }}</template>
          </el-input>
        </el-col>
        <el-col :xs="24" :sm="10" style="padding: 5px 0px;">
          <el-radio-group v-model="attach.addedWeightType" size="mini">
            <el-radio-button :label="0">{{ msg('固定值') }}</el-radio-button>
            <el-radio-button :label="1">{{ msg('百分比值') }}</el-radio-button>
          </el-radio-group>
        </el-col>
        <el-col :xs="24" :sm="14" style="padding: 5px 0px;">
          <div style="max-width: 300px;">
            <el-input v-if="attach.addedWeightType===0" v-model="attach.addedWeight"
                      :placeholder="msg('固定增加重量')" size="mini">
              <!-- <template slot="prepend">{{"添加重量值"}}</template> -->
              <template slot="append">KG</template>
            </el-input>
            <el-input v-else-if="attach.addedWeightType===1" v-model="attach.addedPercentWeight"
                      :placeholder="msg('按百分比增加重量')" size="mini">
              <!-- <template slot="prepend">{{"添加重量值"}}</template> -->
              <template slot="append">%</template>
            </el-input>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="7" style="padding: 10px 5px">
          <el-switch v-model="attach.disabled"
                     inactive-text="是否启用" @click.native="setDefault(idx, 'attachWeights')"
                     :active-value="1" :inactive-value="0"
                     active-color="#13ce66" inactive-color="#ff4949">
          </el-switch>
          <el-link style="margin-left:20px;" icon="el-icon-delete"
                   type="danger" :underline="false"
                   @click="form.attachWeights.splice(idx, 1);">{{ msg('删除') }}
          </el-link>
        </el-col>
      </el-row>
      <div style="text-align:center;">
        <el-button type="primary" @click="addWeight()" plain size="mini">添加更多</el-button>
      </div>
    </div>
    <div style="text-align:center; margin-top: 15px; margin-bottom:15px;">
      <el-button type="primary" size="mini" @click="update"><i class="el-icon-check"></i><span>{{
          msg('确定')
        }}</span>
      </el-button>
    </div>
  </el-form>
</template>

<script>
export default {
  name: "UserSettingWeighing",
  data() {
    return {
      xgroup: 'ATTACH_WEIGHT',  //电子秤group
      form: {
        attachWeights: [],//附加重量
      }
    }
  },
  mounted() {
    this.getSettings();
  },
  methods: {
    getSettings() {
      var _this = this;
      this.$axios.get(this.$kit.api.user.settingList + "?xgroup=" + this.xgroup)
          .then((result) => {
            if (result.status) {
              this.buildViewData(result.data); //构建设置对象
            }
          });
    },
    buildViewData(data) {
      var _this = this;
      _this.form.attachWeights = [];

      let attachs = data; //附加重量数据

      //附加重量
      if (attachs.length > 0) {
        attachs.forEach(a => {
          if (a.xvalue) {
            let ws = JSON.parse(a.xvalue);

            let weight = ws.addedWeight;
            let pweight = ws.addedPercentWeight;
            let type = ws.addedWeightType;

            if (type == 1) {
              pweight = pweight * 100;
            }

            let wsset = {
              id: a.id,
              disabled: a.disabled,
              addedWeightType: type,
              addedWeight: weight,
              addedPercentWeight: pweight,
              owner: a.owner,
              xlabel: a.xlabel
            }
            _this.form.attachWeights.push(wsset);
          }
        });
      }

    },
    addWeight() {
      this.form.attachWeights.push({
        id: null,
        disabled: 0,
        addedWeightType: 0,
        addedWeight: null,
        addedPercentWeight: null,
        owner: null,
        xlabel: "设置" + (this.form.attachWeights.length + 1),
      });
    },
    update() {
      let datas = [];
      //构建附加重量
      for (let i = 0; i < this.form.attachWeights.length; i++) {
        let attach = this.form.attachWeights[i];
        let key = this.xgroup + i;

        let pweight = attach.addedPercentWeight;
        let type = attach.addedWeightType;
        let weight = attach.addedWeight;
        if (type == 0) {
          pweight = 0;
        } else {
          weight = 0;
          if (pweight) {
            pweight = (pweight / 100).toFixed(2);
          }
        }

        datas.push({
          id: attach.id,
          disabled: attach.disabled,
          xkey: key,
          xlabel: attach.xlabel,
          owner: attach.owner ? attach.owner : null,
          xgroup: this.xgroup,
          xvalue: JSON.stringify({
            addedWeightType: type,
            addedWeight: weight,
            addedPercentWeight: pweight
          }),
        });
      }

      var _this = this;
      _this.$axios.post(_this.$kit.api.user.settingUpdate + "?xgroup=" + this.xgroup, datas).then((result) => {
        _this.$message(result.msg)
      });
    }
  }
}
</script>

<style scoped>

</style>